import React from "react";
import { NoSymbolIcon } from "@heroicons/react/20/solid";

export default function PaymentFailed({ handelModalType }) {
  const onOkClick = () => handelModalType(null);
  return (
    <div className="bg-[#141414] border border-gray-800 p-8 px-6 md:px-16 rounded-2xl flex flex-col justify-center items-center md:mx-auto text-white shadow-2xl max-w-md w-full text-center">
      <div className="w-20 h-20 bg-red-500/10 border border-red-500/20 rounded-full flex items-center justify-center mb-6">
        <NoSymbolIcon className="h-10 w-10 text-red-500" />
      </div>
      <div>
        <h3 className="md:text-2xl text-xl text-white font-bold text-center mb-2">
          Transaction Failed
        </h3>
        <p className="text-gray-400 my-2 text-sm md:text-base">
          Your Transaction has failed.
        </p>
        <p className="text-gray-400 text-sm mb-6">
          Please check your card details and try again.
        </p>
        <button
          onClick={onOkClick}
          className="w-full bg-secondary hover:bg-orange-500 text-white font-semibold py-3 px-8 rounded-xl transition-all hover:scale-[1.02] active:scale-95 shadow-md shadow-secondary/20"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
